export const slugs = {
  login: "/login",

  dashboard: "/",

  users: "/users",
  user: "/users/:id",

  laundpads: "/laundpads",
  laundpad: "/laundpads/:id",

  nfts: "/nfts",
  flipNFTs: "/flip-nfts",
  flipNFTsDetail: "/flip-nfts/:collectionId",
  artistCollectionDetail: "/artist-collections/:id",
  nftViews: "/nft-views",
  nft: "/nfts/:id",
  transactionnft: "/transactionnft",

  transactions: "/transactions",
  transaction: "/transaction-details",

  reward: "/reward",

  locked: "/locked",

  backgrounds: "/backgrounds",

  sponsors: "/sponsors",
  sponsor: "/sponsors/:id",

  notfound: "/404",
  createNftManual: "/create-nft-manual",

  policies: "/policies",

  reports: "/reports",
};
